import React, { useEffect, useState } from 'react'
import SidePanel from '../../../../../../ui/SidePanel/SidePanel'
import './SpecificationsBlock.sass'
import getFieldRenderObject from '../../../../../../utils/newforms/render/getFieldRenderObject'
import { createForm } from '../../../../../../utils/newforms/createForm'
import FormRender from '../../../../../../utils/newforms/render/FormRender'
import { isEmpty } from 'lodash'

const blocks = [
  {
    id: 'descriptionLong',
    title: 'Інформація про продукт',
    type: 'texteditor',
  },
  {
    id: 'benefits',
    title: 'Переваги',
    type: 'texteditor',
  },
  {
    id: 'useType',
    title: 'Спосіб застосування',
    type: 'texteditor',
  },
  {
    id: 'composition',
    title: 'Склад',
    type: 'texteditor',
  },
]

function SpecificationsBlock({ formData, syncState }) {
  const [form, setForm] = useState(null)
  const [activeBlockId, setActiveBlockId] = useState(blocks[0].id)
  const [showErrors] = useState(false)

  useEffect(() => {
    setForm(
      createForm({
        formPattern: new SpecificationsForm(),
        formData,
      })
    )
  }, [formData])

  useEffect(() => {
    if (!isEmpty(form)) {
      syncState(form)
    }
    // Parent passes an inline syncState callback, so watching its identity
    // causes a render loop while syncing nested form state upward.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form])

  return (
    <div className="SpecificationsBlock">
      <SidePanel
        title="Додаткові характеристики товару"
        content={
          <div className="BrandsList-Container">
            {blocks.map((b) => (
              <div
                key={b.id}
                className={`Brand ${activeBlockId === b.id ? 'Brand_theme_active' : ''}`}
                onClick={() => setActiveBlockId(b.id)}
              >
                {b.title}
              </div>
            ))}
          </div>
        }
      />
      <div className="ContentBlock">
        <FormRender
          sections={[
            {
              fields: [activeBlockId],
            },
          ]}
          form={form}
          setForm={setForm}
          errors={showErrors}
        />
      </div>
    </div>
  )
}

class SpecificationsForm {
  constructor() {
    blocks.forEach((b) => {
      if (b.type === 'texteditor') {
        this[b.id] = {
          field: {
            fieldId: b.id,
            fieldType: 'texteditor',
            label: b.title,
            required: false,
          },
          render: getFieldRenderObject(),
        }
      }
    })
  }
}

export default SpecificationsBlock
